import { render } from "./WaitingPage.vue?vue&type=template&id=574ffb1c&scoped=true"
import script from "./WaitingPage.vue?vue&type=script&lang=js"
export * from "./WaitingPage.vue?vue&type=script&lang=js"

import "./WaitingPage.vue?vue&type=style&index=0&id=574ffb1c&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574ffb1c"]])

export default __exports__